export default __webpack_public_path__ + "static/media/mutual.f9362076.png";